module.exports = __webpack_public_path__ + "assets/img/ftr_facebook.webp?4329da7df0d6f17076c75dd5a6148e54";